import React, { Component } from "react";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import residentReducer from "../Resident/reducers";
import ResidentForm from "../Resident/ResidentForm";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const configureStore = (initialState = {}) => {
  return createStore(
    residentReducer,
    initialState,
    composeEnhancers(
      applyMiddleware(
        thunk
      )
    )
  );
}

class ResidentErrorBoundary extends Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    fetch("/log_js_error", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        message: error?.message,
        stack: error?.stack,
        source: "resident_component",
        component: errorInfo?.componentStack,
        url: window.location.href,
      }),
    }).catch(() => {});
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-4 text-center">
          <p className="text-danger font-weight-bold">Something went wrong loading this profile.</p>
          <p className="text-muted small">{this.state.error?.message}</p>
          <button className="btn btn-primary btn-sm" onClick={() => window.location.reload()}>
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default class Resident extends Component {
  render() {
    return (
      <Provider store={configureStore(this.props)}>
        <ResidentErrorBoundary>
          <ResidentForm stripe_api_key={this.props.stripe_api_key}/>
        </ResidentErrorBoundary>
      </Provider>
    );
  }
}
